/**
 * @module ol/ViewHint
 */

/**
 * @enum {number}
 */
export default {
  ANIMATING: 0,
  INTERACTING: 1
};

//# sourceMappingURL=ViewHint.js.map


// WEBPACK FOOTER //
// ./~/ol/ViewHint.js